import { render } from "./sjjdetail.vue?vue&type=template&id=d85f3b86&scoped=true&ts=true"
import script from "./sjjdetail.vue?vue&type=script&lang=ts"
export * from "./sjjdetail.vue?vue&type=script&lang=ts"

import "./sjjdetail.vue?vue&type=style&index=0&id=d85f3b86&lang=scss&scoped=true"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d85f3b86"]])

export default __exports__